import React from 'react';

import dayjs from 'dayjs';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { MdAccessTimeFilled } from 'react-icons/md';

import Tracker from 'modules/common/components/Tracker';

function AddressDetails({ data }) {
  const animateOff =
    data?.system_status === 'DELIVERED' || data?.system_status === 'CANCELLED';

  const renderAddress = () => {
    if (data?.is_customer_pickup) {
      return [
        {
          id: 1,
          isActive: true,
          title: data?.branch_pinned_address,
        },
      ];
    }

    return [
      {
        id: 1,
        isActive: true,
        title: data?.branch_pinned_address,
        description: 'Delivering From',
      },
      {
        id: 2,
        isActive: true,
        title: data?.customer_address,
        description: 'Delivering To',
      },
    ];
  };

  const renderScheduledAt = React.useMemo(() => {
    const { scheduled_delivery_date = null, scheduled_at = null } = data;
    const { min, max } = data?.scheduled_delivery_date || {};
    const $scheduled_delivery_date = scheduled_delivery_date
      ? `Expect delivery between ${dayjs(min).format('ll')} - ${dayjs(
          max
        ).format('ll')}`
      : null;
    const label = $scheduled_delivery_date || scheduled_at;

    if (!(data?.scheduled_delivery_date || data?.scheduled_at)) return null;
    return (
      <div className="flex items-center gap-4">
        <MdAccessTimeFilled className="h-6 w-6" />
        <div className="text-sm font-semibold">{label}</div>
      </div>
    );
  }, [data]);

  if (data?.is_customer_pickup && !isEmpty(data?.brand_pinned_address))
    return null;
  return (
    <div className="space-y-4">
      <h4 className="font-medium text-gray-400 text-xs">
        {data?.is_customer_pickup ? 'PICKUP DETAILS' : 'DELIVERY DETAILS'}
      </h4>
      <div className="space-y-2">
        {renderScheduledAt}
        <Tracker
          animateOff={animateOff}
          borderStyle="border-dashed"
          finalDestinationIcon={
            <FaMapMarkerAlt className="h-4 w-4 text-primary-500" />
          }
          finalIcon={<FaMapMarkerAlt className="h-6 w-6 text-primary-500" />}
          data={renderAddress()}
        />
      </div>
    </div>
  );
}

AddressDetails.defaultProps = {
  data: {},
};

AddressDetails.propTypes = {
  data: PropTypes.instanceOf(Object),
};

export default AddressDetails;
